import { FC } from "react";

import { AverageConsumptionLineChart, AverageConsumptionDataPoint } from "../AverageConsumptionLineChart/AverageConsumptionLineChart";
import { AVERAGE_WATER_CONSUMPTION_DISHWASHERS_DATA_KEYS } from "./AverageWaterConsumptionDishwashers.const";

const AverageWaterConsumptionDishwashers: FC<{ data: AverageConsumptionDataPoint[] }> = ({ data }) => (
	<AverageConsumptionLineChart
		data={data}
		yAxisLabel="Average water consumption of dishwashers"
		chartSubtitle="(liters per cycle)"
		yDomain={[0, 20]}
		yTickCount={5}
		dataKeys={AVERAGE_WATER_CONSUMPTION_DISHWASHERS_DATA_KEYS}
	/>
);

export { AverageWaterConsumptionDishwashers };
